module.exports = __webpack_public_path__ + "media/images/kyoto_zh-hant01-6effca74cd098932f9bd73ea4e6e4058.jpg";